import Appointment from '../appointments/appointmentModel'

export default class Client {
  _key: string
  id: string
  firstName: string
  lastName: string
  nickName: string
  email: string
  phone: string
  appointments: Appointment[]
  completedAppointments: Appointment[]

  constructor(instance: any) {
    this._key = instance._key
    this.id = instance.id
    this.firstName = instance.firstName
    this.lastName = instance.lastName
    this.nickName = instance.nickName
    this.email = instance.email
    this.phone = instance.phone
    let appointments: Appointment[] = []
    if (instance.appointments && instance.appointments.length > 0) {
      instance.appointments.forEach((a: any) => {
        appointments.push(new Appointment(a))
      })
    }
    this.appointments = appointments
    this.completedAppointments = instance.completedAppointments
  }
}
